export default __webpack_public_path__ + "static/media/kamin-default.e5cb09fc.jpg";